/** Выбор усиления «1 из 3» — чистая модель без DOM. */
import { type BoostOption } from "@newfungame/engine";

/**
 * Порядок совета новичку: сначала то, что сразу видно на поле — зомби падают быстрее (урон, темп, снаряды),
 * затем крит и эффекты по площади, потом пушка и навыки, защита штаба и в самом конце монеты (их эффект в бою
 * не виден). Эпические и редкие усиления, бьющие по урону, стоят выше обычного темпа: они сильнее за одно взятие.
 */
export const BOOST_ADVICE_ORDER: readonly string[] = [
  "boost_damage_up",
  "boost_overdrive",
  "boost_multishot",
  "boost_fire_rate",
  "boost_crit_damage",
  "boost_ricochet",
  "boost_ignite",
  "boost_crit_chance",
  "boost_frost_aura",
  "boost_skill_power",
  "boost_cannon_power",
  "boost_cannon_rapid",
  "boost_long_range",
  "boost_quick_skills",
  "boost_hq_armor",
  "boost_hq_regen",
  "boost_coin_rush",
  "boost_endless_damage",
  "boost_endless_coins",
  "boost_endless_armor",
];

const RARITY_RANK = { epic: 0, rare: 1, common: 2 } as const;

/**
 * Индекс рекомендованной карточки (`BoostOption.index`), `null` — предложение пустое. Правило: усиление выше всех
 * в {@link BOOST_ADVICE_ORDER}; неизвестные списку (новые в данных) — после известных, между собой — по редкости
 * (эпическое → обычное), затем по позиции в предложении. Взятые до максимума не советуем.
 */
export function recommendBoost(options: readonly BoostOption[]): number | null {
  const open = options.filter((o) => o.maxStacks === null || o.stacks < o.maxStacks);
  const pool = open.length > 0 ? open : options;
  if (pool.length === 0) return null;
  const rank = (o: BoostOption) => {
    const i = BOOST_ADVICE_ORDER.indexOf(o.boostId);
    return i >= 0 ? i : BOOST_ADVICE_ORDER.length + RARITY_RANK[o.rarity];
  };
  let best = pool[0]!;
  for (const o of pool) if (rank(o) < rank(best) || (rank(o) === rank(best) && o.index < best.index)) best = o;
  return best.index;
}

/** Совет (рамка и палец) — только в первые выборы: игрок ещё не видел окно и не проходил дальше 2-й волны. */
export const BOOST_HINT_MAX_BEST_WAVE = 2;

export function shouldShowBoostHint(bestWave: number, seen: boolean): boolean {
  return !seen && bestWave <= BOOST_HINT_MAX_BEST_WAVE;
}
